import React from "react";
import ErrorBoundary from "./ErrorBoundary";

const ErrorBoundaryHandler = (Component: any) => ({ ...props }) => (
  <ErrorBoundary>
    <Component {...props} />
  </ErrorBoundary>
);
export default ErrorBoundaryHandler;